import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { connect } from 'react-redux';

import { CHANGEABLE_CATEGORIES } from 'constants/outfits';

export class EmptySlot extends Component {
  handleClick = () => {
    if (!this.isChangeable()) {
      return;
    }
    const { name, onOpenQualityPicker } = this.props;
    onOpenQualityPicker(name);
  }

  isChangeable = () => {
    const { name } = this.props;
    return CHANGEABLE_CATEGORIES.indexOf(name) >= 0;
  }

  render = () => {
    const { isChanging } = this.props;
    return (
      <div
        role="button"
        tabIndex={-1}
        onClick={this.handleClick}
        onKeyUp={this.handleClick}
        className={classnames(
          'icon icon--inventory',
          // "equipped-group__equipped",
          isChanging && 'equipped-group__equipped--is-changing',
          'equipped-shortlist__empty-slot',
        )}
      />

    );
  }
}

EmptySlot.displayName = 'EmptySlot';

EmptySlot.propTypes = {
  isChanging: PropTypes.bool.isRequired,
  name: PropTypes.string.isRequired,
  onOpenQualityPicker: PropTypes.func.isRequired,
};

const mapStateToProps = ({ outfit: { isChanging } }) => ({ isChanging });

export default connect(mapStateToProps)(EmptySlot);